import { Component, OnDestroy, OnInit } from '@angular/core';

import { SharedModule } from '../../../shared.module';
import { _BaseButtonComponent } from 'src/app/features/shared/controls/components/_base-button.component';
import { ButtonData } from '../../models/button-data';
import { IButtonData } from '../../models/_base-button';
import { ButtonActionData } from '../../models/button-action-data';

@Component({
    selector: 'app-button-action',
    templateUrl: './button-action.component.html',
    styleUrls: [
        '../../buttons.scss',
        './button-action.component.scss'
    ],
    standalone: true,
    host: {
        '[class.disabled]': '_disabled$$()',
    },
    imports: [
        SharedModule,
    ]
})
export class ButtonActionComponent
    extends _BaseButtonComponent
    implements OnInit, OnDestroy
{
    override autofocus$$       = this._input_autofocus$$;
    override buttonData$$      = this._input_buttonData$$;
    override class$$           = this._input_class$$;
    override color$$           = this._input_color$$;
    override disabled$$        = this._input_disabled$$;
    override fontSize$$        = this._input_fontSize$$;
    override formName$$        = this._input_formName$$;
    override hide$$            = this._input_hide$$;
    override hover$$           = this._input_hover$$;
    override loadKey$$         = this._input_loadKey$$;
    override lockOnLoad$$      = this._input_lockOnLoad$$;
    override style$$           = this._input_style$$;
    override tabIndex$$        = this._input_tabIndex$$;
    override text$$            = this._input_text$$;
    override tooltip$$         = this._input_tooltip$$;
    override tooltipPosition$$ = this._input_tooltipPosition$$;
    override type$$            = this._input_type$$;

    override btnClickEmit = this._out_btnClickEmit;

    ngOnInit(): void {
        super._ngOnInit();
    }
    ngOnDestroy(): void {
        super._ngOnDestroy();
    }
}
